import script from "./VehicleHealth.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleHealth.vue?vue&type=script&setup=true&lang=js"

import "./VehicleHealth.vue?vue&type=style&index=0&id=d1944a86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1944a86"]])

export default __exports__